import { Link, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { Text } from './Text';

export function Privacy(): ReactElement {
  return (
    <Text>
      <Typography variant="h1" className="mb-4">
        Allgemeine Information über die Verarbeitung Ihrer Daten
      </Typography>
      <Typography>
        Wir sind gesetzlich verpflichtet, Sie über die Verarbeitung Ihrer personenbezogenen Daten (im Weiteren „Daten“)
        bei Nutzung unserer Websites zu informieren. Die vorliegende Datenschutzunterrichtung informiert Sie über die
        Einzelheiten der Verarbeitung Ihrer Daten sowie über Ihre diesbezüglichen gesetzlichen Rechte. Für
        Begrifflichkeiten, wie z.B. „personenbezogene Daten“ oder „Verarbeitung“ sind die gesetzlichen Definitionen aus
        Art. 4 DSGVO maßgebend. Wir behalten uns vor, die Datenschutzerklärung mit Wirkung für die Zukunft anzupassen,
        insbesondere im Fall der Weiterentwicklung der Website, bei der Nutzung neuer Technologien oder der Änderung der
        gesetzlichen Grundlagen bzw. der entsprechenden Rechtsprechung. Wir empfehlen Ihnen, die Datenschutzerklärung
        von Zeit zu Zeit zu lesen und einen Ausdruck bzw. eine Kopie zu Ihren Unterlagen zu nehmen.
      </Typography>
      <section>
        <Typography variant="h2">Geltungsbereich</Typography>
        <Typography>
          Die Datenschutzerklärung gilt für alle Seiten von{' '}
          <Link href="https://kundenportal.e2m.energy/">https://kundenportal.e2m.energy/</Link> und{' '}
          <Link href="https://www.e2m.energy/de/">https://www.e2m.energy/de/</Link>. Sie erstreckt sich nicht auf etwaig
          verlinkte Websites bzw. Internetpräsenzen von anderen Anbietern. Sofern im Folgenden keine Differenzierung
          hinsichtlich einzelner Verarbeitungsvorgänge vorgenommen wird, gelten die Inhalte dieser
          Datenschutzinformationen für beide genannten Websites.
        </Typography>
      </section>
      <section>
        <Typography variant="h2">Verantwortlicher</Typography>
        <Typography>
          Für die Verarbeitung von personenbezogenen Daten im Geltungsbereich dieser Datenschutzerklärung ist
          verantwortlich:
        </Typography>
        <Typography>
          Energy2market GmbH
          <br />
          Weißenfelser Str. 84
          <br />
          04229 Leipzig
          <br />
          Telefon: <Link href="tel:+4934123028">+49 341 230 28</Link>
          <br />
          E-Mail: <Link href="mailto:servicecenter@e2m.energy">servicecenter[at]e2m.energy</Link>
        </Typography>
      </section>
      <section>
        <Typography variant="h2">Fragen zum Datenschutz</Typography>
        <Typography>
          Sollten Sie Fragen zum Thema Datenschutz im Hinblick auf unser Unternehmen bzw. unsere Website haben, können
          Sie sich an unseren Datenschutzbeauftragten wenden:
        </Typography>
        <Typography>
          SPIRIT LEGAL Rechtsanwaltsgesellschaft mbH
          <br />
          Rechtsanwalt und Datenschutzbeauftragter
          <br />
          Peter Hense
        </Typography>
        <Typography>
          Postanschrift:
          <br />
          Datenschutzbeauftragter
          <br />
          c/o Energy2market GmbH, Weißenfelser Str. 84, 04229 Leipzig
        </Typography>
        <Typography>
          Kontaktaufnahme über das verschlüsselte Onlineformular:
          <br />
          <Link href="https://www.spiritlegal.com/de/datenschutzbeauftragter-anfragen.html">
            Datenschutzbeauftragten kontaktieren
          </Link>
        </Typography>
      </section>
      <section>
        <Typography variant="h2">Sicherheit</Typography>
        <Typography>
          Wir haben umfassende technische und organisatorische Vorkehrungen getroffen, um Ihre personenbezogenen Daten
          vor unberechtigtem Zugriff, Missbrauch, Verlust und anderen äußeren Störungen zu schützen. Hierzu überprüfen
          wir unsere Sicherheitsmaßnahmen regelmäßig und passen sie dem Stand der Technik an.
        </Typography>
      </section>
      <section>
        <Typography variant="h2">Ihre Rechte</Typography>
        <Typography>
          Sie haben die folgenden Rechte im Hinblick auf die Sie betreffenden personenbezogenen Daten, die Sie uns
          gegenüber geltend machen können:
        </Typography>
        <ul>
          <li>
            <strong>Recht auf Auskunft</strong>: Sie können Auskunft nach Maßgabe von Art. 15 DSGVO über Ihre
            personenbezogenen Daten verlangen, die wir verarbeiten.
          </li>
          <li>
            <strong>Recht auf Berichtigung</strong>: Sollten die Sie betreffenden Angaben nicht (mehr) zutreffend sein,
            können Sie nach Art. 16 DSGVO eine Berichtigung verlangen. Sollten Ihre Daten unvollständig sein, können Sie
            eine Vervollständigung verlangen.
          </li>
          <li>
            <strong>Recht auf Löschung</strong>: Sie können nach Maßgabe von Art. 17 DSGVO die Löschung Ihrer
            personenbezogenen Daten verlangen.
          </li>
          <li>
            <strong>Recht auf Einschränkung der Verarbeitung</strong>: Sie haben nach Maßgabe von Art. 18 DSGVO das
            Recht, eine Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
          </li>
          <li>
            <strong>Recht auf Widerspruch gegen die Verarbeitung</strong>: Sie haben das Recht, aus Gründen, die sich
            aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Ihrer personenbezogenen Daten, die
            aufgrund von Art. 6 Abs. 1 S. 1 lit. e) oder lit. f) DSGVO erfolgt, nach Art. 21 Abs. 1 DSGVO Widerspruch
            einzulegen. Wir werden Ihre Daten in diesem Fall nicht weiterverarbeiten, es sei denn, wir können zwingende
            schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechten und Freiheiten
            überwiegen. Eine weitere Verarbeitung findet zudem statt, wenn die Verarbeitung der Geltendmachung und
            Ausübung von oder der Verteidigung gegen Rechtsansprüche dient (Art. 21 Abs. 1 DSGVO). Außerdem steht Ihnen
            nach Art. 21 Abs. 2 DSGVO das Recht zu, jederzeit Widerspruch gegen die Verarbeitung Ihrer personenbezogenen
            Daten zum Zwecke der Direktwerbung einzulegen; dies gilt auch für ein etwaiges Profiling, soweit es mit
            solcher Direktwerbung in Verbindung steht. Wir weisen Sie auf das Widerspruchsrecht in dieser
            Datenschutzerklärung im Zusammenhang mit der jeweiligen Verarbeitung hin.
          </li>
          <li>
            <strong>Recht auf Widerruf Ihrer Einwilligung</strong>: Soweit Sie für eine Verarbeitung Ihre Einwilligung
            erteilt haben, steht Ihnen nach Art. 7 Abs. 3 DSGVO ein Widerrufsrecht zu.
          </li>
          <li>
            <strong>Recht auf Datenübertragbarkeit</strong>: Sie haben das Recht, die Sie betreffenden personenbezogenen
            Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu
            erhalten („Datenübertragbarkeit“) sowie das Recht auf Weiterübermittlung dieser Daten an einen anderen
            Verantwortlichen, wenn die Voraussetzung des Art. 20 Abs. 1 lit. a, b DSGVO vorliegen (Art. 20 DSGVO).
          </li>
        </ul>
        <Typography>
          Sie können Ihre Rechte durch Mitteilung an die im Abschnitt „Verantwortlicher“ genannten Kontaktdaten bzw.
          gegenüber den von uns benannten Datenschutzbeauftragten geltend machen.
        </Typography>
        <Typography>
          Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen Datenschutzrecht
          verstößt, haben Sie zudem nach Art. 77 DSGVO das Recht, sich bei einer Datenschutzaufsichtsbehörde eigener
          Wahl zu beschweren. Hierzu gehört auch die für den Verantwortlichen zuständige Datenschutzaufsichtsbehörde:
        </Typography>
        <Typography>
          Sächsische Datenschutz- und Transparenzbeauftragte, Postfach 110132, 01330 Dresden oder: Devrientstraße 5,
          01067 Dresden, Telefon: <Link href="tel:+4935185471-101">+49 351 85471-101</Link>, E-Mail:{' '}
          <Link href="mailto:post@sdtb.sachsen.de">post@sdtb.sachsen.de</Link>,{' '}
          <Link href="https://www.saechsdsb.de/">https://www.saechsdsb.de/</Link>.
        </Typography>
      </section>
      <section>
        <Typography variant="h2">Nutzung unserer Website / des Kundenportals</Typography>
        <Typography>
          Sie können unsere Websites grundsätzlich ohne Offenlegung Ihrer Identität zu rein informatorischen Zwecken
          nutzen. Beim Abruf der einzelnen Seiten der Websites in diesem Sinne werden lediglich Zugriffsdaten an unseren
          Webspace-Provider übermittelt, damit Ihnen die Websites angezeigt werden können. Die folgenden Daten werden
          hierbei verarbeitet:
        </Typography>
        <ul>
          <li>Browsertyp/Browserversion,</li>
          <li>verwendetes Betriebssystem,</li>
          <li>Sprache und Version der Browsersoftware,</li>
          <li>Datum und Uhrzeit des Zugriffs,</li>
          <li>IP-Adresse,</li>
          <li>Inhalt der Anforderung (konkrete Webseite),</li>
          <li>Zugriffsstatus/HTTP-Statuscode,</li>
          <li>Referrer URL (die zuvor besuchte Website),</li>
          <li>Meldung, ob der Aufruf erfolgreich war,</li>
          <li>Verbindungsstatus.</li>
        </ul>
        <Typography>
          Die vorübergehende Verarbeitung dieser Daten ist notwendig, um den Ablauf eines Websitebesuchs und eine
          Auslieferung der jeweiligen Website an Ihr Endgerät technisch zu ermöglichen. Die Zugriffsdaten werden nicht
          zur Identifizierung von einzelnen Nutzern verwendet und nicht mit anderen Datenquellen zusammengeführt. Eine
          weitere Speicherung in Protokolldateien (Logfiles) erfolgt, um die Funktionsfähigkeit der Website und die
          Sicherheit der informationstechnischen Systeme zu gewährleisten. Rechtsgrundlage für die Verarbeitung ist Art.
          6 Abs. 1 S. 1 lit. f) DSGVO. Unsere berechtigten Interessen liegen in der Sicherstellung der
          Funktionsfähigkeit der Website sowie der Integrität und Sicherheit der Website. Das Speichern von
          Zugriffsdaten in Logfiles, insbesondere der IP-Adresse, für einen längeren Zeitraum ermöglicht es uns,
          Missbrauch zu erkennen und abwehren zu können. Hierzu zählt etwa die Abwehr der den Dienst überlasteten
          Anfragen oder eine etwaige Bot-Nutzung. Die Zugriffsdaten werden gelöscht, sobald sie für die Erreichung des
          Zweckes ihrer Verarbeitung nicht mehr erforderlich sind – in der Regel nach 30 Tagen. Die Protokolldaten
          werden grundsätzlich direkt und ausschließlich für Administratoren zugänglich aufbewahrt und spätestens nach
          30 Tagen gelöscht. Danach sind sie nur noch indirekt über die Rekonstruktion von Sicherungsbändern (Backups)
          verfügbar und werden nach maximal 365 Tagen endgültig gelöscht.
        </Typography>
        <Typography className="underline">
          Sie können Widerspruch gegen die Verarbeitung einlegen. Ihr Widerspruchsrecht besteht bei Gründen, die sich
          aus Ihrer besonderen Situation ergeben. Sie können uns Ihren Widerspruch über die im Abschnitt
          „Verantwortlicher“ genannten Kontaktdaten zukommen lassen.
        </Typography>
      </section>
      <section>
        <Typography variant="h2">Endgeräteinformationen</Typography>
        <Typography>
          Über die zuvor genannten Zugriffsdaten hinaus werden bei der Nutzung der Websites Technologien verwendet,
          welche Informationen in Ihrer Endeinrichtung (z.B. Desktop-PC, Laptop, Tablet und Smartphone) speichern oder
          auf Informationen zugreifen, die bereits in Ihrer Endeinrichtung gespeichert sind. Bei diesen Technologien
          kann es sich beispielsweise um sog. Cookies, Pixel, LocalStorage, SessionStorage, IndexedDB oder
          Browser-Fingerprinting Technologien handeln. Diese Technologien können dazu genutzt werden, Sie geräte- und
          websiteübergreifend wiederzuerkennen.
        </Typography>
        <Typography>
          Gem. § 25 Abs. 1 TTDSG benötigen wir zum Einsatz dieser Technologien grundsätzlich Ihre Einwilligung. Eine
          solche ist nach § 25 Abs. 2 TTDSG nur dann nicht erforderlich, wenn die Technologien entweder die Übertragung
          einer Nachricht über ein öffentliches Telekommunikationsnetz ermöglichen oder wenn sie unbedingt erforderlich
          sind, um einen von Ihnen ausdrücklich gewünschten Telemediendienst zur Verfügung zu stellen:
        </Typography>
        <section>
          <Typography variant="h3">Technisch notwendige Endgeräteinformationen</Typography>
          <Typography>
            Einige Elemente unserer Internetseiten dienen dem alleinigen Zweck der Übertragung einer Nachricht (§ 25
            Abs. 2 Nr. 1 TTDSG) oder sind unbedingt erforderlich, um Ihnen unsere Websites oder einzelne
            Funktionalitäten der jeweiligen Website zur Verfügung zu stellen (§ 25 Abs. 2 Nr. 2 TTDSG).
          </Typography>
          <Typography>
            Sie können die Verarbeitung verhindern, indem Sie entsprechende Einstellungen Ihrer Browser-Software
            vornehmen. Bei Elementen, deren Speicherdauer nicht auf die Session begrenzt ist, können Sie die Elemente
            nach Ablauf Ihrer Session in den Einstellungen Ihrer Browser-Software löschen.
          </Typography>
        </section>
        <section>
          <Typography variant="h3">Technisch nicht notwendige Endgeräteinformationen</Typography>
          <Typography>
            Wir verwenden auf unseren Websites darüber hinaus Elemente, die nicht technisch notwendig sind. Diese
            Technologien setzen wir gemäß den gesetzlichen Vorgaben nur mit Ihrer Einwilligung ein. Informationen zu den
            einzelnen Technologien und Funktionen finden Sie in den Auswahlmöglichkeiten vor dem Abspielen des
            eingebetteten Dienstes sowie geordnet nach den einzelnen Funktionen in den nachfolgenden Informationen.
          </Typography>
        </section>
      </section>
      <section>
        <Typography variant="h2">Kontaktaufnahme mit unserem Unternehmen</Typography>
        <Typography>
          Bei einer Kontaktaufnahme mit unserem Unternehmen, z.B. per E-Mail oder über das Kontaktformular auf den
          Websites, werden die von Ihnen mitgeteilten personenbezogenen Daten von uns verarbeitet, um Ihre Anfrage zu
          beantworten. Zwingend erforderlich sind für die Bearbeitung von Anfragen über das Kontaktformular die Angabe
          eines Vor- und Nachnamens sowie einer validen E-Mail-Adresse. Rechtsgrundlage für die Verarbeitung ist Art. 6
          Abs. 1 S. 1 lit. f) DSGVO bzw. Art. 6 Abs. 1 S. 1 lit. b) DSGVO, wenn die Kontaktaufnahme auf den Abschluss
          eines Vertrages abzielt. Sofern die Anfrage auf einen Vertragsschluss abzielt, sind die Angaben Ihrer Daten
          erforderlich und verpflichtend. Bei Nichtbereitstellung der Daten sind ein Vertragsschluss bzw. die
          -durchführung und die Bearbeitung der Anfrage nicht möglich. Die im Rahmen der Kontaktaufnahme und
          -bearbeitung anfallenden Daten löschen wir, nachdem die Verarbeitung nicht mehr erforderlich ist – in der
          Regel zwei Jahre nach Beendigung der Kommunikation – oder schränken die Verarbeitung gegebenenfalls auf die
          Einhaltung der bestehenden gesetzlich zwingenden Aufbewahrungspflichten ein.
        </Typography>
        <Typography className="underline">
          Sie können Widerspruch gegen die Verarbeitung einlegen. Ihr Widerspruchsrecht besteht bei Gründen, die sich
          aus Ihrer besonderen Situation ergeben. Sie können uns Ihren Widerspruch über die im Abschnitt
          „Verantwortlicher“ genannten Kontaktdaten zukommen lassen.
        </Typography>
      </section>
      <section>
        <Typography variant="h2">Verarbeitung zu vertraglichen Zwecken</Typography>
        <Typography>
          Wir verarbeiten Ihre personenbezogenen Daten, wenn und soweit dies für die Anbahnung, Begründung, Durchführung
          und/oder Beendigung eines Rechtsgeschäfts mit unserem Unternehmen erforderlich ist. Die Rechtsgrundlage
          hierfür ergibt sich aus Art. 6 Abs. 1 S. 1 lit. b) DSGVO. Die Bereitstellung Ihrer Daten ist für den
          Vertragsschluss erforderlich und Sie sind vertraglich verpflichtet, Ihre Daten zur Verfügung zu stellen. Bei
          Nichtbereitstellung Ihrer Daten ist ein Vertragsabschluss und/oder die -durchführung nicht möglich. Nach der
          Zweckerreichung (z.B. Vertragsabwicklung) werden die personenbezogenen Daten für eine weitere Verarbeitung
          gesperrt bzw. gelöscht, soweit wir nicht aufgrund einer von Ihnen erteilten Einwilligung (z.B. Einwilligung in
          die Verarbeitung der E-Mail-Adresse für Zusendung von elektronischer Werbepost), einer vertraglichen
          Vereinbarung, einer gesetzlichen Ermächtigung (z.B. Ermächtigung zur Zusendung von Direktwerbung) oder
          aufgrund berechtigter Interessen (z.B. Aufbewahrung zur Durchsetzung von Ansprüchen) zu einer weiteren
          Verarbeitung befugt sind.
        </Typography>
        <Typography>Die Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt insoweit, wenn</Typography>
        <ul>
          <li>
            es für die Begründung, Durchführung oder Beendigung von Rechtsgeschäften mit unserem Unternehmen
            erforderlich ist (z.B. bei der Weitergabe von Daten an einen Zahlungsdienstleister/ ein Versandunternehmen
            zur Abwicklung eines Vertrages mit Ihrer Person), gemäß Art. 6 Abs. 1 S. 1 lit. b) DSGVO, oder
          </li>
          <li>
            ein Unterauftragnehmer oder Erfüllungsgehilfe, den wir ausschließlich im Rahmen der Erbringung der von Ihnen
            gewünschten Angebote oder Dienste einsetzen, diese Daten benötigt (solche Hilfspersonen sind, soweit Ihnen
            nicht ausdrücklich etwas anderes mitgeteilt wird, nur insoweit zur Verarbeitung der Daten berechtigt, als
            dies für die Erbringung des Angebots oder Services notwendig ist), oder
          </li>
          <li>eine vollstreckbare behördliche Anordnung (Art. 6 Abs. 1 S. 1 lit. c) DSGVO) vorliegt, oder</li>
          <li>eine vollstreckbare gerichtliche Anordnung vorliegt (Art. 6 Abs. 1 S. 1 lit. c) DSGVO), oder</li>
          <li>wir von Gesetzes wegen (Art. 6 Abs. 1 S. 1 lit. c) DSGVO) hierzu verpflichtet sind, oder</li>
          <li>
            die Verarbeitung erforderlich ist, um lebenswichtige Interessen der betroffenen Person oder einer anderen
            natürlichen Person zu schützen (Art. 6 Abs. 1 S. 1 lit. d) DSGVO), oder
          </li>
          <li>
            es für die Wahrnehmung einer Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung
            öffentlicher Gewalt erfolgt (Art. 6 Abs. 1 S. 1 lit. e) DSGVO), oder
          </li>
          <li>
            wir uns auf unsere überwiegenden berechtigten Interessen oder eines Dritten zur Weitergabe berufen können
            (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
          </li>
        </ul>
        <Typography>
          Eine darüberhinausgehende Weitergabe Ihrer personenbezogenen Daten an andere Personen, Unternehmen oder
          Stellen erfolgt nicht, es sei denn, Sie haben in eine solche Weitergabe wirksam eingewilligt. Rechtsgrundlage
          der Verarbeitung ist dann Art. 6 Abs. 1 S. 1 lit. a) DSGVO. Wir weisen Sie im Rahmen dieser
          Datenschutzinformationen in Bezug auf den jeweiligen Verarbeitungsvorgang auf die jeweiligen Empfänger hin.
        </Typography>
        <Typography>
          Sofern wir die im Rahmen dieser Datenschutzinformationen genannten und verarbeiteten personenbezogenen Daten
          nicht direkt von Ihnen erhalten, beziehen wir diese im Rahmen der Vertragsbeziehung insbesondere aus folgenden
          Quellen:
        </Typography>
        <ul>
          <li>Marktstammdatenregister</li>
          <li>
            Vertriebspartner im Rahmen des Kundensupports (siehe weitere Informationen in Abschnitt „
            <em>Verarbeitung im Rahmen der gemeinsamen Verantwortlichkeit</em>“ dieser Datenschutzerklärung)
          </li>
          <li>Anlagenspezifische Steuerungssysteme.</li>
        </ul>
      </section>
      <section>
        <Typography variant="h2">Kundenportal</Typography>
        <Typography>
          Um auf das Kundenportal auf unserer Website nutzen zu können, müssen Sie sich mit Ihrer E-Mail-Adresse und
          einem selbst gewähltem Passwort im Kundenportal registrieren. Es besteht kein Klarnamenszwang, eine pseudonyme
          Nutzung steht Ihnen frei. Des Weiteren wird im Zeitpunkt der Registrierung Ihre IP-Adresse verarbeitet.
        </Typography>
        <Typography>
          Wir verwenden für die Registrierung und die Verwaltung der Logins im Kundenportal einen erweiterten
          Multi-Faktor-Authentifizierungsprozess mithilfe eines Einmalcodes mit Zeitablauf („One-Time-Code“), der bei
          jeder Sitzung zur Verifikation von Ihnen als Kunden benötigt wird. Nachdem Sie die für die Registrierung
          erforderlichen Daten über die Eingabemasken übermittelt haben, werden Sie zur Verifikation Ihres Endgerätes
          sowie zu Sicherheitszwecken gebeten, einen One-Time-Code einzugeben, den Sie wahlweise mithilfe der externen
          Dienste „Google Authenticator“ (Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Ireland) oder
          „FreeOTP Authenticator“ (Red Hat, Inc., 100 East Davie Street, Raleigh, North Carolina 27601, USA und Red Hat
          Ltd., 6700 Cork Airport Business Park, Phase II 1st Floor, Cork, Ireland; im Weiteren: „RedHat“) aus den
          gängigen App-Stores (Google Play: Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Ireland oder
          Apple App Store: Apple Inc., 1 Infinite Loop, Cupertino, CA 95014, USA) oder durch ein lokal auf dem
          jeweiligen Endgerät zu installierendes Programm „2FAst“ des Anbieters J.P. Weber IT aus dem Microsoft
          App-Store (Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399, USA) auch ohne Internetverbindung
          generieren können. Das Verifikationsverfahren wird mithilfe der genannten Software bzw. Apps durchgeführt.
          Hierfür wird auf dem jeweils registrierten bzw. im Anmeldeprozess verwendeten Endgerät ein einmalig gültiger
          Code erzeugt, der zur Verifikation des Endgeräts im Kundenportal auf der Website angegeben werden muss.
        </Typography>
        <Typography>
          Beim Herunterladen der mobilen Apps aus den genannten App-Stores werden die erforderlichen Informationen und
          Ihre hierbei eingegebenen Daten zudem an den von Ihnen ausgewählten App Store „Google Play“ oder „Apple App
          Store“ übermittelt, insbesondere Nutzername, E-Mail-Adresse und Kundennummer Ihrer Accounts, Zeitpunkt des
          Downloads, Zahlungsinformationen und die individuelle Gerätekennziffer. Auf diese Datenverarbeitung durch
          Apple und Google haben wir keinen Einfluss und sind hierfür nicht verantwortlich. Wir verarbeiten Daten nur,
          soweit es für das Herunterladen der mobilen App auf Ihr mobiles Endgerät notwendig ist. Apple und Google
          verarbeiten Ihre Daten unter Umständen auch in den USA. Wir haben mit Apple und Google
          Standardvertragsklauseln vereinbart. Auf Anfrage stellen wir Ihnen eine Kopie zur Verfügung. Weitere
          Informationen zum Datenschutz, insbesondere zur Speicherdauer, finden Sie bei Apple unter{' '}
          <Link href="https://www.apple.com/legal/privacy/de-ww/">https://www.apple.com/legal/privacy/de-ww/</Link> und
          bei Google unter{' '}
          <Link href="https://policies.google.com/privacy?hl=de&gl=de">
            https://policies.google.com/privacy?hl=de&gl=de
          </Link>
          .
        </Typography>
        <Typography>
          Sofern Sie sich über die erwähnten Smartphone-Apps registrieren, können Sie zum Einrichten Ihres Kontos
          wahlweise den von uns bereitgestellten QR-Code aus der Anmeldemaske scannen oder sich eine Zeichenfolge
          anzeigen lassen, die Sie in der gewählten Authenticator-App eingeben. Erst nach erfolgter Aktivierung des
          jeweiligen Codes und der Eingabe dieser in das hierfür vorgesehene Feld auf unserer Website wird der Zugang zu
          Ihrem Kundenkonto angelegt und die Registrierung erfolgreich abgeschlossen. Bei späteren Anmeldungen (Logins)
          sind die von Ihnen bei der ersten Anmeldung gewählten Zugangsdaten (Benutzerkennung und Passwort) sowie der
          für jede Sitzung neu zu generierende einmalige Code einzugeben.
        </Typography>
        <Typography>
          Die im Zusammenhang mit dem Kundenportal von Ihnen verarbeiteten Daten werden gelöscht, sobald sie für die
          Erreichung des Zweckes der Verarbeitung nicht mehr erforderlich sind. Dies ist für die während des
          Registrierungsvorgangs erhobenen Daten der Fall, wenn die Registrierung auf der Website aufgehoben oder
          abgeändert wird.
        </Typography>
        <Typography>In dem Login-Bereich stehen Ihnen folgende Funktionen bereit:</Typography>
        <ul>
          <li>Stammdatenübersicht,</li>
          <li>Erstellen und Bearbeiten von Energieerzeugungs- sowie Regelenergieprognosen,</li>
          <li>Melden von Anlageausfällen,</li>
          <li>Einsehen von Vermarktungserlösen,</li>
          <li>Versenden von Kontaktanfragen.</li>
        </ul>
        <Typography>
          Soweit Sie das Kundenportal nutzen, um z.B. Anlageausfälle zu melden und Prognosen zu aktualisieren,
          verarbeiten wir auch die zur Vertragsanbahnung bzw. Vertragserfüllung erforderlichen personenbezogenen,
          insbesondere Adressdaten.
        </Typography>
        <Typography>
          Rechtsgrundlage der Verarbeitung im Rahmen des Kundenportals ist Art. 6 Abs. 1 S. 1 lit. b) DSGVO. Die
          Bereitstellung Ihrer Daten ist für den Vertragsschluss bzw. die -durchführung erforderlich und verpflichtend.
          Bei Nichtbereitstellung Ihrer Daten können Sie sich weder registrieren noch das Kundenportal nutzen, d. h. ein
          Vertragsabschluss und/oder die -durchführung sind nicht möglich. Ihre Daten werden gelöscht, sobald sie für
          den Verarbeitungszweck nicht mehr erforderlich sind. Dies ist der Fall nach Löschung des Kundenkontos, soweit
          wir nicht aufgrund gesetzlicher Vorschriften zur Aufbewahrung der hierbei verarbeiteten Daten verpflichtet
          sind. In diesem Fall schränken wir die Verarbeitung ein. Aufgrund zwingender handels- und steuerrechtlicher
          Vorschriften sind wir verpflichtet, Ihre Adress-, Zahlungs- und Bestelldaten für die Dauer von bis zu zehn
          Jahren aufzubewahren.
        </Typography>
        <Typography>
          Rechtsgrundlage für die Verarbeitung seitens der im Rahmen der Multi-Faktor-Authentifizierung eingesetzten
          Dienstleister ist Art. 6 Abs. 1 S. 1 lit. f) DSGVO. Mit der Verarbeitung verfolgen wir die berechtigten
          Interessen, Ihre Kundendaten durch einen zusätzlichen Authentifizierungsprozess zu schützen. „Google“ und
          „RedHat“ verarbeiten die im Rahmen des Verifikationsprozesses erhobenen Daten zum Teil auch in den USA. Für
          einen Datentransfer in die USA existiert ein{' '}
          <Link href="https://ec.europa.eu/commission/presscorner/detail/en/ip_23_3721">
            Angemessenheitsbeschluss der EU-Kommission
          </Link>
          . Es wurden zusätzlich mit „Google“ und „RedHat“ sog. Standardvertragsklauseln abgeschlossen. Eine Kopie der
          Standardvertragsklauseln erhalten Sie unter{' '}
          <Link href="https://cloud.google.com/terms/sccs">https://cloud.google.com/terms/sccs</Link> sowie{' '}
          <Link href="https://www.redhat.com/en/about/agreements/dpl">
            https://www.redhat.com/en/about/agreements/dpl
          </Link>
          . Weitere Informationen zum Datenschutz und zur Speicherdauer bei „Google“ erhalten Sie auf{' '}
          <Link href="https://policies.google.com/privacy">https://policies.google.com/privacy</Link> sowie{' '}
          <Link href="https://www.redhat.com/en/about/privacy-policy">
            https://www.redhat.com/en/about/privacy-policy
          </Link>
          .
        </Typography>
      </section>
      <section>
        <Typography variant="h2">E-Mail-Marketing</Typography>
        <section>
          <Typography variant="h3">Bestandskundenwerbung</Typography>
          <Typography>
            Wir behalten uns vor, die von Ihnen im Rahmen der Registrierung innerhalb des Kundenportals bzw. der
            insofern bereits bestandenen Kundenbeziehung mitgeteilte E-Mail-Adresse entsprechend den gesetzlichen
            Vorschriften dazu zu verwenden, um Ihnen per E-Mail folgende Inhalte zu übersenden, sofern Sie dieser
            Verarbeitung Ihrer E-Mail-Adresse nicht bereits widersprochen haben:
          </Typography>
          <ul>
            <li>
              Interessante Angebote aus unserem Portfolio, insbesondere bezogen auf Marktreports, Stromvermarktung,
              Vermarktungsoptionen, Optimierungen etc.,
            </li>
            <li>Sonderangebote / zeitlich befristete Angebote,</li>
            <li>Technische Informationen,</li>
            <li>Neue Angebote zu Serviceleistungen unserer Produkte und Dienstleistungen,</li>
            <li>Einladungen zu Veranstaltungen unseres Unternehmens,</li>
            <li>Anfragen zu Kundenfeedback/Kundenzufriedenheit,</li>
            <li>Übersichten über anlagenspezifische Einspeiseprognosen und technische Messwerte,</li>
            <li>Überblick über aktuelle Entwicklungen an Stromhandelsmärkten.</li>
          </ul>
          <Typography>
            Rechtsgrundlage der Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f) DSGVO. Unsere berechtigten Interessen
            an der genannten Verarbeitung liegen in der Steigerung und Optimierung unserer Serviceleistungen, Versendung
            von Direktwerbung und Sicherstellung der Kundenzufriedenheit. Wir löschen Ihre Daten, wenn Sie den
            Nutzungsvorgang beenden, spätestens jedoch drei Jahre nach Vertragsbeendigung.
          </Typography>
          <Typography className="underline">
            Wir weisen Sie darauf hin, dass Sie dem Erhalt von Direktwerbung sowie der Verarbeitung zum Zwecke der
            Direktwerbung jederzeit widersprechen können, ohne dass Ihnen hierfür andere als die Übermittlungskosten
            nach den Basistarifen entstehen. Dabei stehen Ihnen ein generelles Widerspruchsrecht ohne Angaben von
            Gründen zu (Art. 21 Abs. 2 DSGVO). Klicken Sie hierzu auf den Abmeldelink in der jeweiligen E-Mail oder
            übersenden Sie uns Ihren Widerspruch an die im Abschnitt „Verantwortlicher“ genannten Kontaktdaten.
          </Typography>
        </section>
        <section>
          <Typography variant="h3">Newsletter</Typography>
          <Typography>
            Sie haben zudem die Möglichkeit, unsere E-Mail-Newsletter zu erhalten, mit dem wir Sie regelmäßig über
            folgende Inhalte informieren:
          </Typography>
          <ul>
            <li>
              Interessante Angebote aus unserem Portfolio, insbesondere bezogen auf Marktreports, Stromvermarktung,
              Vermarktungsoptionen, Optimierungen etc.,
            </li>
            <li>Sonderangebote / zeitlich befristete Angebote,</li>
            <li>Technische Informationen,</li>
            <li>Neue Angebote zu Serviceleistungen unserer Produkte und Dienstleistungen,</li>
            <li>Einladungen zu Veranstaltungen unseres Unternehmens,</li>
            <li>Anfragen zu Kundenfeedback/Kundenzufriedenheit,</li>
            <li>Übersichten über anlagenspezifische Einspeiseprognosen und technische Messwerte,</li>
            <li>Überblick über aktuelle Entwicklungen an Stromhandelsmärkten.</li>
          </ul>
          <Typography>
            Für den Empfang des Newsletters ist die Angabe Ihres Namens oder Pseudonyms sowie einer validen
            E-Mail-Adresse erforderlich. Wir verarbeiten die E-Mail-Adresse zum Zweck der Zusendung unseres
            E-Mail-Newsletters und solange Sie den Newsletter abonniert haben. Für den Versand des Newsletters bedienen
            wir uns eines externen E-Mail-Marketingdienstes. Weitere Informationen zu diesem Dienstleister erhalten Sie
            in den Abschnitten „E-Mail-Marketing-Dienste“.
          </Typography>
          <Typography>
            Rechtsgrundlage der Verarbeitung ist Ihre Einwilligung gemäß Art.{' '}
            <Link href="https://beck-online.beck.de/?typ=reference&y=100&a=6&g=EWG_DSGVO">6</Link> Abs.{' '}
            <Link href="https://beck-online.beck.de/?typ=reference&y=100&a=6&g=EWG_DSGVO&x=1">1</Link> S. 1 lit. a)
            DSGVO.
          </Typography>
          <Typography className="underline">
            Ihre Einwilligung zur Verarbeitung Ihrer E-Mail-Adresse für den Empfang des Newsletters können Sie jederzeit
            widerrufen, entweder durch direkten Klick auf den Abmeldelink im jeweiligen Newsletter oder indem Sie uns
            über die unter „Verantwortlicher“ angegebenen Kontaktdaten eine Mitteilung zusenden. Dies hat keinen
            Einfluss auf die Rechtmäßigkeit der Verarbeitung, die aufgrund der Einwilligung bis zum Zeitpunkt Ihres
            Widerrufs erfolgt ist.
          </Typography>
          <Typography>
            Im Falle einer Abmeldung durch Ausübung des Widerrufs der Einwilligungserklärung verarbeiten wir Ihre Daten,
            insbesondere Ihre E-Mail-Adresse, um sicherzustellen, dass Sie keine weiteren Newsletter von uns erhalten.
            Zu diesem Zweck fügen wir Ihre E-Mail-Adresse einer sogenannten <strong>„Sperrliste“</strong> zu, die es
            ermöglicht, dass Sie keine weiteren Newsletter von uns erhalten. Rechtsgrundlage für die Datenverarbeitung
            ist Art. 6 Abs. 1 S. 1 lit. c) DSGVO, um unseren Nachweispflichten nachzukommen, anderenfalls Art. 6 Abs. 1
            S. 1 lit. f) DSGVO. Unsere berechtigten Interessen bestehen in diesem Fall in der Einhaltung unserer
            gesetzlichen Pflichten, Ihnen gegenüber zuverlässig keine Newsletter mehr zuzustellen.
          </Typography>
          <Typography className="underline">
            Sie können Widerspruch gegen die Verarbeitung einlegen. Ihr Widerspruchsrecht besteht bei Gründen, die sich
            aus Ihrer besonderen Situation ergeben. Sie können uns Ihren Widerspruch über die im Abschnitt
            „Verantwortlicher“ genannten Kontaktdaten zukommen lassen.
          </Typography>
          <Typography>
            Daneben verarbeiten wir die vorgenannten Daten für die{' '}
            <strong>Begründung, Ausübung oder Verteidigung von Rechtsansprüchen</strong>. Rechtsgrundlage für die
            Verarbeitung ist Art. 6 Abs. 1 lit. c) DSGVO und Art. 6 Abs. 1 lit. f) DSGVO. In diesen Fällen besteht unser
            berechtigtes Interesse an der Geltendmachung oder Abwehr von Ansprüchen.
          </Typography>
          <Typography className="underline">
            Sie können Widerspruch gegen die Verarbeitung einlegen. Ihr Widerspruchsrecht besteht bei Gründen, die sich
            aus Ihrer besonderen Situation ergeben. Sie können uns Ihren Widerspruch über die im Abschnitt
            „Verantwortlicher“ genannten Kontaktdaten zukommen lassen.
          </Typography>
          <Typography>
            Wir werten auch Öffnungsraten der Newsletter, die Klickanzahl von enthaltenen Links und die Lesedauer
            statistisch aus. Zu diesem Zweck wird das Nutzungsverhalten auf unseren Webauftritten sowie innerhalb der
            von uns versendeten Newsletter anhand von endgerätespezifischen Informationen (z.B. verwendeter
            E-Mail-Client und Softwareeinstellungen) ausgewertet. Für diese Analyse enthalten die versandten E-Mails
            sogenannte Web-Beacons oder Tracking-Pixel, welche Ein-Pixel-Bilddateien darstellen, die ebenfalls auf
            unserer Website eingebettet sind. Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. a) DSGVO. Wir
            löschen Ihre Daten, wenn Sie das Newsletter-Abonnement beenden.
          </Typography>
          <Typography className="underline">
            Ein Widerruf Ihrer Einwilligung ist jederzeit möglich, entweder per Nachricht an uns (vgl. die Kontaktdaten
            im Abschnitt „Verantwortlicher”) oder indem Sie direkt den im Newsletter enthaltenen Link zur Abmeldung
            betätigen. Dies hat keinen Einfluss auf die Rechtmäßigkeit der Verarbeitung, die aufgrund der Einwilligung
            bis zum Zeitpunkt Ihres Widerrufs erfolgt ist.
          </Typography>
        </section>
        <section>
          <Typography variant="h3">E-Mail-Marketing-Dienst</Typography>
          <Typography>Wir nutzen folgenden E-Mail-Marketing-Dienst:</Typography>
          <ul>
            <li>
              „<strong>CleverReach</strong>” des Anbieters CleverReach GmbH & Co. KG (CRASH Building, Schafjückenweg 2,
              26180 Rastede, Deutschland; im Weiteren: „CleverReach”); weitere Informationen finden Sie in den
              Datenschutzbestimmungen von „CleverReach“ unter{' '}
              <Link href="https://www.cleverreach.com/de-de/datenschutz/">
                https://www.cleverreach.com/de-de/datenschutz/
              </Link>
              .
            </li>
          </ul>
          <Typography>
            Wenn Sie sich für den Newsletter angemeldet haben, werden die bei der Anmeldung mitgeteilten Daten sowie die
            während der Nutzung unseres Newsletterangebots verarbeiteten Daten auf den Servern unseres vorgenannten
            E-Mail-Marketing-Dienstes verarbeitet. Der E-Mail-Marketing-Dienst fungiert als unser Auftragsverarbeiter
            und ist vertraglich in seiner Befugnis beschränkt, Ihre personenbezogenen Daten für andere Zwecke als die
            Erbringung von Dienstleistungen für uns in Übereinstimmung mit dem geltenden Datenverarbeitungsvertrag zu
            verwenden. Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. f) DSGVO. Unsere berechtigten
            Interessen am Einsatz eines externen E-Mail-Marketing-Diensts liegen in der Optimierung und gezielteren
            Steuerung und Überwachung unserer Newsletter-Inhalte.
          </Typography>
          <Typography className="underline">
            Sie können Widerspruch gegen die Verarbeitung einlegen, sofern sie auf Art. 6 Abs. 1 S. 1 lit. f) DSGVO
            beruht. Ihr Widerspruchsrecht besteht bei Gründen, die sich aus Ihrer besonderen Situation ergeben. Sie
            können uns Ihren Widerspruch über die im Abschnitt „Verantwortlicher“ genannten Kontaktdaten zukommen
            lassen.
          </Typography>
        </section>
      </section>
      <section>
        <Typography variant="h2">Rechtsdurchsetzung/Adressermittlung/Inkasso</Typography>
        <Typography>
          Wir behalten uns vor, im Falle einer Nichtzahlung, die bei der Bestellung mitgeteilten Daten zu Zwecken der
          Adressermittlung und/oder Rechtsdurchsetzung an einen Rechtsanwalt und/oder an externe Unternehmen (z.B.
          Verband der Vereine Creditreform e.V., Hellersbergstraße 12, D-41460 Neuss) weiterzureichen. Rechtsgrundlage
          der Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. f) DSGVO. Unsere berechtigten Interessen liegen in der
          Betrugsprävention und der Vermeidung von Ausfallrisiken. Darüber hinaus werden wir Ihre Daten gegebenenfalls
          weitergeben, um die Wahrnehmung unserer Rechte, sowie der Rechte der mit uns verbundenen Unternehmen, unserer
          Kooperationspartner, unserer Arbeitnehmer und/oder der Nutzer unserer Website sicherzustellen und die
          Verarbeitung insofern erforderlich ist. Keinesfalls werden wir Ihre Daten an Dritte verkaufen oder vermieten.
          Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. f) DSGVO. Wir haben ein berechtigtes
          Interesse an der Verarbeitung zur Rechtsdurchsetzung. Die anfallenden Daten löschen wir, nachdem die
          Speicherung nicht mehr erforderlich ist, oder schränken die Verarbeitung ein, falls gesetzliche
          Aufbewahrungspflichten bestehen.
        </Typography>
        <Typography className="underline">
          Sie können Widerspruch gegen die Verarbeitung einlegen. Ihr Widerspruchsrecht besteht bei Gründen, die sich
          aus Ihrer besonderen Situation ergeben. Sie können uns Ihren Widerspruch über die im Abschnitt
          „Verantwortlicher“ genannten Kontaktdaten zukommen lassen.
        </Typography>
      </section>
      <section>
        <Typography variant="h2">Hosting</Typography>
        <Typography>
          Wir verwenden externe Hosting-Leistungen des Anbieters Leonmedia GmbH (Kantstraße 53, 04275 Leipzig), die der
          Zurverfügungstellung der folgenden Leistungen dienen: Infrastruktur- und Plattformdienstleistungen,
          Rechenkapazität, Sicherheits- sowie technische Wartungsleistungen. Zu diesen Zwecken werden sämtliche Daten –
          unter anderem die unter dem Punkt „Nutzung unserer Website“ genannten Zugriffsdaten – verarbeitet, die für den
          Betrieb und die Nutzung unserer Website erforderlich sind. Rechtsgrundlage für die Verarbeitung ist Art. 6
          Abs. 1 S. 1 lit. f) DSGVO. Wir verfolgen mit dem Einsatz externer Hosting-Leistungen eine effiziente und
          sichere Zurverfügungstellung unseres Webangebots.
        </Typography>
        <Typography className="underline">
          Sie können Widerspruch gegen die Verarbeitung einlegen. Ihr Widerspruchsrecht besteht bei Gründen, die sich
          aus Ihrer besonderen Situation ergeben. Sie können uns Ihren Widerspruch über die im Abschnitt
          „Verantwortlicher“ genannten Kontaktdaten zukommen lassen.
        </Typography>
      </section>
      <section>
        <Typography variant="h2">Einbindung von Inhalten Dritter</Typography>
        <Typography>
          Auf den Websites sind Inhalte Dritter, wie z.B. Videos von anderen Websites eingebunden. Diese Integration
          setzt immer voraus, dass die Anbieter dieser Inhalte („Drittanbieter”) die IP-Adressen der Nutzer wahrnehmen.
          Denn ohne die IP-Adresse können sie die Inhalte nicht an den Browser des jeweiligen Nutzers senden. Die
          IP-Adresse ist damit für die Darstellung dieser Inhalte erforderlich. Wir informieren Sie nachfolgend über die
          aktuell auf unserer Website eingesetzten Dienste externer Anbieter sowie über die jeweilige Verarbeitung im
          Einzelfall und über Ihre bestehenden Widerspruchs- oder Widerrufsmöglichkeiten:
        </Typography>
        <section>
          <Typography variant="h3">YouTube-Videos</Typography>
          <Typography>
            Wir verwenden auf unseren Websites Plug-ins der Videoplattform „YouTube.de“ bzw. „YouTube.com“, einem Dienst
            der YouTube, LLC (Hauptgeschäftssitz in 901 Cherry Avenue, San Bruno, CA 94066, USA; im Weiteren:
            „YouTube“), für den „Google“ (Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Irland und Google,
            LLC, 1600 Amphitheatre Parkway Mountain View, CA 94043, USA; im Weiteren: „Google“) Verantwortlicher i.S.d.
            Datenschutzrechts ist. Mittels der Verarbeitung von Daten durch die Plug-ins verfolgen wir den Zweck,
            visuelle Inhalte („Videos“), die wir auf „Youtube.de“ bzw. „Youtube.com“ veröffentlicht haben, auch auf
            dieser Website einzubinden. Die Videos sind alle im „erweiterten Datenschutz-Modus“ eingebunden, d. h., dass
            keine Daten über Sie als Nutzer an „YouTube“ übertragen werden, wenn Sie die Videos nicht abspielen. Während
            des Abspielens von Videos auf unserer Website erhält „YouTube“ die Information, dass Sie die entsprechende
            Unterseite unserer Website aufgerufen haben. Zudem werden zum Teil die unter dem Abschnitt „Nutzung unserer
            Website“ genannten Daten an „Google“ übermittelt. Dies erfolgt unabhängig davon, ob „YouTube“ ein
            Nutzerkonto bereitstellt, über das Sie eingeloggt sind, oder ob kein Nutzerkonto besteht. Wenn Sie bei
            „Google“ eingeloggt sind, werden Ihre Daten direkt Ihrem Konto zugeordnet. Wenn Sie die Zuordnung mit Ihrem
            Profil bei „YouTube“ nicht wünschen, müssen Sie sich vor Aktivierung des Buttons ausloggen. „YouTube“
            speichert Ihre Daten als Nutzungsprofile und verarbeitet sie unabhängig vom Vorhandensein eines Nutzerkontos
            bei „Google“ für Zwecke der Werbung, Marktforschung und/oder bedarfsgerechten Gestaltung seiner Website.
            Hinsichtlich der Speicherung von und des Zugriffs auf Informationen in Ihrem Endgerät ist Rechtsgrundlage §
            25 Abs. 1 TTDSG; für die weitere Verarbeitung ist Rechtsgrundlage Art. 6 Abs. 1 S. 1 lit. a) DSGVO. „Google“
            verarbeitet die Daten zum Teil auch in den USA. Für einen Datentransfer in die USA existiert ein{' '}
            <Link href="https://ec.europa.eu/commission/presscorner/detail/en/ip_23_3721">
              Angemessenheitsbeschluss der EU-Kommission
            </Link>
            . Im Rahmen dessen ist Google zertifiziert. Es wurden mit Google, LLC zusätzlich sog.
            Standardvertragsklauseln abgeschlossen. Eine Kopie der Standardvertragsklauseln erhalten Sie unter{' '}
            <Link href="https://cloud.google.com/terms/sccs">https://cloud.google.com/terms/sccs</Link>. Weitere
            Informationen zu Zweck und Umfang der Verarbeitung durch „YouTube“ und der Speicherdauer bei „YouTube“ bzw.
            „Google“ erhalten Sie in der Datenschutzerklärung von „Google“ unter{' '}
            <Link href="https://policies.google.com/privacy">https://policies.google.com/privacy</Link>.
          </Typography>
          <Typography className="underline">
            Ein Widerruf Ihrer Einwilligungen in die Verarbeitung ist jederzeit möglich, indem Sie den Button unterhalb
            des YouTube-Videos „Einwilligung für YouTube widerrufen“ betätigen. Die Rechtmäßigkeit der Verarbeitung
            bleibt bis zur Ausübung des Widerrufs unberührt.
          </Typography>
        </section>
      </section>
      <section>
        <Typography variant="h2">
          Verarbeitung im Rahmen der gemeinsamen Verantwortlichkeit mit externen Vertriebspartnern
        </Typography>
        <section>
          <Typography variant="h3">Hintergrund / Zwecke der Verarbeitung</Typography>
          <Typography>
            Um unsere Produkte am Energiemarkt zu platzieren und zu vermarkten, setzen wir Vertriebspartner ein, die in
            den direkten e2m-Kunden- bzw. Erzeugerkontakt involviert sind. Zudem ist es uns mithilfe von
            Vertriebspartnern möglich, eine intensive Kundenbetreuung sicherzustellen sowie die fortlaufende Optimierung
            der Entwicklung der jeweiligen Kundenanlagen und der dahinterstehenden Prognose- und Erzeugungsdaten zu
            gewährleisten. Der Vertriebspartner vermittelt hierbei u.a. seinen Kunden unsere Produkte und mithin den
            Vertragsschluss zwischen uns und den betroffenen Personen, z.B. Neukunden.
          </Typography>
          <Typography>
            Zu diesen Zwecken verarbeiten Vertriebspartner gemeinsam mit uns personenbezogene Daten (z.B.
            Personenstammdaten, Unternehmensstammdaten, Ansprechpartner:innen) insbesondere im Rahmen unseres
            Kundenportals. Ihre Daten werden somit sowohl durch uns als auch durch Vertriebspartner der Energy2market
            GmbH verarbeitet. In diesem Zusammenhang sind wir mit unseren Vertriebspartnern hinsichtlich der
            Verarbeitung von personenbezogenen Daten zur Kundenbetreuung, zum Vertragsmanagement, der Optimierung der
            Kundenanlage sowie zu Zwecken der Direkt- und Flexibilitätsvermarktung gemeinsam Verantwortliche gemäß Art.
            26 DSGVO.
          </Typography>
          <Typography>
            Unsere Vertriebspartner erheben personenbezogene Daten entweder im Rahmen des Vertragsschlusses bzw. der
            Kundenbetreuung direkt von den betreffenden Kunden oder erhalten diese von uns zum Zwecke der Kommunikation
            über unser Energy2market-Kundenportal. Dies erfolgt zum Zwecke der Kommunikation mit Erzeugern, insbesondere
            zur Verbesserung der Prognosequalität, der Gewährleistung der Vorhaltung und Erbringung von Regelleistungen
            sowie der Umsetzung technischer Maßnahmen im Zusammenhang mit der Fernsteuerbarkeit und der Flexibilisierung
            von Anlagen. Vertriebspartner verarbeiten Ihre Daten nach erfolgter Übermittlung zudem auch für eigene
            Vermittlungszwecke.
          </Typography>
        </section>
        <section>
          <Typography variant="h3">Verantwortlichkeiten / Geltendmachung von Betroffenenrechten</Typography>
          <Typography>
            Im Rahmen dieser gemeinsamen Datenverarbeitung gemäß Art. 26 DSGVO haben wir mit unseren Vertriebspartnern
            neben des Abschlusses genereller Vertriebspartnerverträge zusätzlich datenschutzrechtliche Vereinbarungen
            darüber getroffen, wer die bestehenden Pflichten u.a. gegenüber Betroffenen nach der DSGVO erfüllt. Dies
            betrifft insbesondere die Ausübung der Rechte der betroffenen Personen und die Erfüllung der
            Informationspflichten nach Artikel 13 und 14 der DSGVO, die wir Betroffenen in präziser, transparenter,
            verständlicher und leicht zugänglicher Form in einer klaren und einfachen Sprache unentgeltlich zur
            Verfügung stellen. Ihre Betroffenenrechte im Rahmen der gemeinsamen Verantwortlichkeit können Sie
            grundsätzlich sowohl gegenüber uns als auch gegenüber den jeweiligen Vertriebspartnern geltend machen, wobei
            wir als Energy2market GmbH als zentrale Anlauf- bzw. Bearbeitungsstelle Ihrer Anfrage fungieren. Die
            jeweiligen Vertriebspartner und wir informieren uns unverzüglich gegenseitig über die Geltendmachung von
            Betroffenenrechten und stellen einander sämtliche für die Beantwortung von Auskunftsersuchen notwendigen
            Informationen zur Verfügung.
          </Typography>
        </section>
        <section>
          <Typography variant="h3">Rechtsgrundlage | Speicherdauer</Typography>
          <Typography>
            Rechtsgrundlage für die gemeinsame Verarbeitung der Daten im Rahmen der Kundenverwaltung ist Art. 6 Abs. 1
            S. 1 lit. b) DSGVO. Die Bereitstellung der personenbezogenen Daten ist für die Vertragsanbahnung und den
            Vertragsschluss erforderlich und Sie sind verpflichtet, Ihre personenbezogenen Daten bereitzustellen. Bei
            Nichtbereitstellung Ihrer Daten ist ein Vertragsabschluss und/oder die -durchführung nicht möglich.
          </Typography>
          <Typography>
            Nach der Zweckerreichung (z.B. Beendigung des Kundenvertrags) werden die personenbezogenen Daten für eine
            weitere Verarbeitung gesperrt bzw. gelöscht, soweit wir nicht aufgrund einer von Ihnen erteilten
            Einwilligung (z.B. Einwilligung in die Verarbeitung der E-Mail-Adresse zum Erhalt elektronischer Werbepost),
            einer vertraglichen Zusatzvereinbarung, einer gesetzlichen Ermächtigung oder aufgrund berechtigter
            Interessen (z.B. Aufbewahrung zur Durchsetzung von Ansprüchen) zu einer weiteren Verarbeitung befugt sind.
          </Typography>
          <Typography>
            Weitere Informationen zur Datenverarbeitung durch den jeweiligen Vertriebspartner und der hierbei geltenden
            Speicherdauer erhalten Sie direkt auf Anfrage gegenüber dem für Sie zuständigen Vertriebspartner, dessen
            Kontaktdaten Sie Ihrem Kundenportal entnehmen können.
          </Typography>
        </section>
        <section>
          <Typography variant="h3">Kontakt</Typography>
          <Typography>
            Bei Fragen im Zusammenhang mit der gemeinsamen Datenverarbeitung können Sie sich an die im Abschnitt
            „Verantwortlicher“ dieser Datenschutzhinweise genannten Kontaktdaten wenden.
          </Typography>
        </section>
      </section>
      <Typography>
        <Link href="https://www.spiritlegal.com/de/">Copyright by Spirit Legal</Link>
      </Typography>
      <Typography>Stand: 25.07.2023</Typography>
    </Text>
  );
}
